import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// import screenshots
import alerts1 from "../../assets/img/docs/watchdog-7.png";
import alerts2 from "../../assets/img/docs/watchdog-8.png";

const Alerts = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-5 alerts-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              {/* Title */}
              <Card.Title className="display-6 mb-3">
                {t("documentation.watchdog.alerts.title")}
              </Card.Title>

              {/* Description */}
              <Card.Text className="text-muted mb-3">
                {t("documentation.watchdog.alerts.description")}
              </Card.Text>

              {/* Alert Types */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.watchdog.alerts.typesTitle")}
              </h5>
              <ul className="overview-list mb-3">
                <li>{t("documentation.watchdog.alerts.types.depleted")}</li>
                <li>{t("documentation.watchdog.alerts.types.warning")}</li>
              </ul>

              {/* How to Access */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.watchdog.alerts.howToAccess.title")}
              </h5>
              <p className="mb-3 text-muted">
                {t("documentation.watchdog.alerts.howToAccess.description")}
              </p>

              {/* Screenshots */}
              <Row className="g-3 mt-2">
                <Col md={4}>
                  <Image
                    src={alerts2}
                    alt="Sidebar navigation Alerts menu"
                    className="section-image"
                    rounded
                    fluid
                    width={150}
                  />
                </Col>
                <Col md={8}>
                  <Image
                    src={alerts1}
                    alt="Alerts table screenshot"
                    className="section-image"
                    rounded
                    fluid
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Alerts;
